import API from "core/networks/API";
import { IApiResponseSuccess } from "core/networks/Interfaces";
import { AxiosResponse, AxiosError } from "axios";
import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  GET_MY_INGREDIENTS_LOCAL,
  FETCH_DATA_MY_INGREDIENTS_REQUEST,
  fetchDataMyIngredientsSuccess,
  fetchDataMyIngredientsError,

  FETCH_DATA_INGREDIENTS_REQUEST,
  fetchDataIngredientsSuccess,
  fetchDataIngredientsError,
  updateDataMyIngredientsLocal,

  GET_MY_INGREDIENTS_REQUEST_LOCAL,
  updateDataMyIngredientsRequestLocal,
  
  UPDATE_MY_INGREDIENTS_REQUEST,
  updateMyIngredientsSuccess,
  updateMyIngredientsError,
  
  REQUEST_INGREDIENT_REQUEST,
  requestNewIngradientSuccess,
  requestNewIngradientError,

  FETCH_DATA_FLAVORS_REQUEST,
  fetchDataFlavorsSuccess,
  fetchDataFlavorsError,
  FETCH_DATA_HISTORY_REQUEST,
  // fetchListHistoryError,
  fetchListHistorySuccess,
} from './actions';
import {
  TIngredient,
  TMyIngredientResponse,
  UpdateMyIngredientsAction,
  RequestNewIngradientAction,
  TFlavor,
  TFlavorItem,
  TFlavorResponse,
  TFlavorItemResponse,
  THistoryResponse,
} from './types';
import {
  API_GET_MY_INGREDIENTS,
  API_GET_INGREDIENTS,
  API_UPDATE_MY_INGREDIENTS,
  API_REQUEST_INGREDIENT,
  API_GET_FLAVORS,
  API_GET_AI_HISTORY,
  // API_GET_LOCAL_MY_INGREDIENTS_BY_LANG,
} from "../api";
import { deviceStorage } from "core/utils/devicestorage";
import { config } from "core/config/app";

const mapIngredientResToStore = (item: TMyIngredientResponse): TIngredient => {
  return {
    id: item.id,
    name: item.name || item.translates?.[0]?.name,
    image: item.icon || '',
    created_at: item.created_at,
  } as TIngredient
}

function* fetchDataIngredients() {
  try {
    const response: AxiosResponse = yield call(
      API.get,
      API_GET_INGREDIENTS,
      {}
    );
    yield put(fetchDataIngredientsSuccess(response.data.data));
  } catch (error) {
    yield put(fetchDataIngredientsError(error as Error));
  }
}

function* getDataMyIngredientsLocal(action: any): any {
  const ingredients: any = yield select((state: any) => state.Ingredients.myIngredients);
  const { lang, user_id } = ingredients
  const auth: any = yield select((state: any) => state.Auth);
  if(!auth?.token) return;
  try {
    if (action.payload.lang !== lang || user_id !== action.payload.user_id) {
      const response: AxiosResponse<IApiResponseSuccess<TMyIngredientResponse[]>> = yield call(
        API.get,
        API_GET_MY_INGREDIENTS,
        {}
      );
      yield put(updateDataMyIngredientsLocal({
        data: response.data.data,
        lang: action.payload.lang,
        user_id
      }));
    }
  } catch (error) {
    yield console.log(error, 'error')
  }
}

function* getDataMyIngredientsRequestLocal(action: any): any {
  const ingredients: any = yield select((state: any) => state.Ingredients.myIngredientsRequested);
  const { lang, user_id } = ingredients
  const auth: any = yield select((state: any) => state.Auth);
  if(!auth?.token) return;
  try {
    if (action.payload.lang !== lang || user_id !== action.payload.user_id) {
      const response: AxiosResponse<IApiResponseSuccess<TMyIngredientResponse[]>> = yield call(
        API.get,
        API_GET_MY_INGREDIENTS,
        {}
      );
      yield put(updateDataMyIngredientsRequestLocal({
        data: response.data.data,
        lang: action.payload.lang,
        user_id
      }));
    }
  } catch (error) {
    yield console.log(error, 'error')
  }
}

function* fetchDataMyIngredients() {
  const token = deviceStorage[
        localStorage.getItem("storage_driver") || "session"
      ].getItem(config.appPackage + "_X_TOKEN");
  if(!token) return;
  try {
    const response: AxiosResponse<IApiResponseSuccess<TMyIngredientResponse[]>> = yield call(
      API.get,
      API_GET_MY_INGREDIENTS,
      {}
    );
    const data = response.data.data.map((item: TMyIngredientResponse) => (
      mapIngredientResToStore(item)
    ));
    yield put(fetchDataMyIngredientsSuccess(data));
  } catch (error) {
    yield put(fetchDataMyIngredientsError(error as Error));
  }
}

function* updateMyIngredients(action: UpdateMyIngredientsAction) {
  try {
    const response: AxiosResponse = yield call(
      API.post,
      API_UPDATE_MY_INGREDIENTS,
      action.payload
    );
    yield put(updateMyIngredientsSuccess(response.data.data));
  } catch (error) {
    yield put(updateMyIngredientsError(error as Error));
  }
}

function* requestNewIngradient(action: RequestNewIngradientAction) {
  try {
    const response: AxiosResponse = yield call(
      API.post,
      API_REQUEST_INGREDIENT,
      action.payload
    );
    yield put(requestNewIngradientSuccess(
      mapIngredientResToStore({
        ...response.data.data,
        // translates: [
        //   {
        //     name: action.payload.ingredient_name
        //   }
        // ]
      })
    ));
  } catch (error) {
    yield put(requestNewIngradientError((error as AxiosError)?.response?.data));
  }
}

function* fetchDataFlavors() {
  try {
    const response: AxiosResponse<IApiResponseSuccess<TFlavorResponse[]>> = yield call(
      API.post,
      API_GET_FLAVORS,
      {}
    );
    const data = response.data.data.map((flavor: TFlavorResponse) => ({
      id: flavor.id,
      sort: flavor.sort,
      name: flavor.translates[0].name,
      flavor_items: flavor.flavor_items.map((item: TFlavorItemResponse) => ({
        id: item.id,
        name: item.translates[0].name,
        text: item.translates[0].name,
      } as TFlavorItem))
    }) as TFlavor);
    yield put(fetchDataFlavorsSuccess(data));
  } catch (error) {
    yield put(fetchDataFlavorsError(error as Error));
  }
}

//fetchDataHistory

function* fetchDataHistory(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<THistoryResponse[]>> = yield call(
      API.get,
      API_GET_AI_HISTORY,
      action.payload
    );
    
    yield put(fetchListHistorySuccess(response?.data?.data));
  } catch (error: any) {
    console.log('error fetchDataHistory', error);
    
    // yield put(fetchListHistoryError(error as Error));
  }
}

export default function* IngredientSaga() {
  yield takeLatest(FETCH_DATA_INGREDIENTS_REQUEST, fetchDataIngredients);
  yield takeLatest(GET_MY_INGREDIENTS_LOCAL, getDataMyIngredientsLocal);
  yield takeLatest(FETCH_DATA_MY_INGREDIENTS_REQUEST, fetchDataMyIngredients);
  yield takeLatest(UPDATE_MY_INGREDIENTS_REQUEST, updateMyIngredients);
  yield takeLatest(FETCH_DATA_FLAVORS_REQUEST, fetchDataFlavors);
  yield takeLatest(REQUEST_INGREDIENT_REQUEST, requestNewIngradient);
  yield takeLatest(GET_MY_INGREDIENTS_REQUEST_LOCAL, getDataMyIngredientsRequestLocal);
  yield takeLatest(FETCH_DATA_HISTORY_REQUEST, fetchDataHistory);

}
